import { render, staticRenderFns } from "./skill-type.vue?vue&type=template&id=719bae00&scoped=true&"
import script from "./skill-type.vue?vue&type=script&lang=js&"
export * from "./skill-type.vue?vue&type=script&lang=js&"
import style0 from "./skill-type.vue?vue&type=style&index=0&id=719bae00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719bae00",
  null
  
)

export default component.exports